<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-text-field
          v-model="search"
          placeholder="Entity Name, UUID, ..."
        ></v-text-field>
        <v-alert
          :value="true"
          type="warning"
          v-if="items.length === 0 && !loading"
        >
          There are no entities for your search query
        </v-alert>
      </v-card-text>
      <v-list three-line v-if="items.length > 0">
        <template v-for="(item, index) in items">
          <v-list-tile
            :key="item.Uuid"
            :to="{ name: 'entity_details', params: { uuid: item.Uuid }}"
            avatar
            ripple
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.Entity_Name }}</v-list-tile-title>
              <v-list-tile-sub-title class="hidden-md-and-up">{{ item.Uuid }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="hidden-sm-and-down">
                <v-chip color="green darken-3" text-color="white" v-if="item.Entity_Status">
                  <v-avatar>
                    <v-icon>check_circle</v-icon>
                  </v-avatar>
                  Active
                </v-chip>
                <v-chip color="red darken-4" text-color="white" v-else>
                  <v-avatar>
                    <v-icon>block</v-icon>
                  </v-avatar>
                  Inactive
                </v-chip>
                <v-chip v-for="tag in item.Tags" :key="tag" color="primary" text-color="white">{{ tag }}</v-chip>
                <v-chip v-for="country_code in item.Country_Code" :key="country_code" color="orange darken-3" text-color="white">
                  <v-avatar>
                    <v-icon>language</v-icon>
                  </v-avatar>
                  {{country_code}}
                </v-chip>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action class="hidden-sm-and-down">
              <v-list-tile-action-text><code>{{ item.Uuid }}</code></v-list-tile-action-text>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import _ from 'underscore'
  import Config from '../utils/Config'
  import AmplifyStore from '../store/store'

  export default {
    data() {
      return {
        selected: null,
        info: null,
        items: [],
        search: '',
        errored: false,
        loading: true,
      }
    },
    watch: {
      search: {
        handler: _.debounce(
          function (value) {

            this.$emit('TriggerLoading', true)

            axios
              .get(`${Config.API_URL}/entity/search?query=${value}`)
              .then(response => {
                this.items = response.data
                this.$emit('TriggerLoading', false)
              })
              .catch(error => {
                console.error(error)
                this.$emit('TriggerLoading', false)
              })
          }, 1000),
      },
    },
    mounted() {

      // console.debug(`AmplifyStore.state.user = ${JSON.stringify(AmplifyStore.state.user)}`)

      this.$emit('TriggerLoading', true)

      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`
      axios
        .get(`${Config.API_URL}/entity/search?query=`)
        .then(response => {
          // console.log(response);
          this.loading = false
          this.items = response.data
          this.$emit('TriggerLoading', false)
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.errored = true
        })
    },
  }
</script>
